import { Color4 } from "babylonjs";

export const EDGE_COLOR = new Color4(0, 0, 0, 1);
export const HIGHLIGHT_EDGE_COLOR = new Color4(112, 50, 64);
